module.exports = __webpack_public_path__ + "static/img/ESGS2022.8c77c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ESGS2022.png
// module id = M79j
// module chunks = 1